module.exports = __webpack_public_path__ + "static/media/points_star_icon.a0cee909.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/points_star_icon.svg
// module id = 137
// module chunks = 0